import { Box, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';
import { SalesEnablementItemProps } from '../../hook';

const Wrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: 240,
  minWidth: 240,
  gridGap: '4px'
});

const Button = styled(SButton)({
  display: 'flex',
  justifyContent: 'flex-start',
  borderRadius: 99,
  padding: 12,
  minWidth: 'unset',
  textAlign: 'left',
  overflow: 'hidden'
});

interface SidebarProps {
  items: SalesEnablementItemProps[];
  activeItem: string;
  setActiveItem: (item: string) => void;
}

export const Sidebar = ({ items, activeItem, setActiveItem }: SidebarProps) => {
  const getTooltipText = (name: string) => (name?.length > 40 ? name : '');

  return (
    <Wrapper>
      {items?.map(({ _id, name, loading }) => (
        <Button
          key={name}
          tooltipTitle={getTooltipText(name)}
          variant="text"
          style={{
            backgroundColor: activeItem === _id && '#E8ECEE',
            fontWeight: 'normal'
          }}
          fullWidth
          disabled={loading}
          loading={loading}
          color="default"
          onClick={() => setActiveItem(_id)}>
          {name}
        </Button>
      ))}
    </Wrapper>
  );
};
